import { FastWarrantiesService } from './../../services/fast-warranties.service';
import { FastWarranty, FastWarrantyAddress, FastWarrantyOwner, FastWarrantyTenant } from './../../models/fast-warranty.model';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { PaginatorStatus, DataTableColumn } from '../generics/data-table/data-table.component';
import { UtilsService } from 'src/app/services/utils.service';
import { ErrorResponse } from 'src/app/models/error.model';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-fast-warranties',
    templateUrl: './fast-warranties.component.html',
    styleUrls: ['./fast-warranties.component.scss']
})
export class FastWarrantiesComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Inquilino', prop: 'inquilino', parseValue: (value: FastWarrantyTenant) => {
            let text = `<span><b>Nombre:</b> ${value.nombre}</span>\n<span><b>Teléfono:</b>${value.telefono}</span>`;
            if (value.documento)
                text += `\n<span><b>Documento:</b> ${value.documento}</span>`;
            if (value.email)
                text += `\n<span><b>Email:</b> ${value.email}</span>`;
            return text;
        } },
        { name: 'Propietario', prop: 'propietario', parseValue: (value: FastWarrantyOwner) => {
            let text = `<span><b>Nombre:</b> ${value.nombre}</span>\n<span><b>Teléfono:</b>${value.telefono}</span>`;
            if (value.documento)
                text += `\n<span><b>Documento:</b> ${value.documento}</span>`;
            if (value.email)
                text += `\n<span><b>Email:</b> ${value.email}</span>`;
            return text;
        } },
        { name: 'Propiedad', prop: 'propiedad', parseValue: (value: FastWarrantyAddress) => {
            let text = '';
            if (value.codigoRemax)
                text += `\n<span><b>Código Remax:</b> ${value.codigoRemax}</span>`;
            if (value.direccion)
                text += `\n<span><b>Dirección:</b> ${value.direccion}</span>`;
            return text;
        } },
        { name: '', width: '140px' }
    ];

    warranties: FastWarranty[];

    constructor(
        private fastWarrantiesService: FastWarrantiesService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getWarranties();
    }

    getWarranties() {
        this.fastWarrantiesService.getFastWarranties(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage).subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.warranties = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener garantías rápidas', error.error?.descripcion));
    }

    updateWarranties(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getWarranties();
    }

    deleteRow(warranty: FastWarranty) {
        const dialog = this.utilsService.confirm('¿Está seguro?', 'Esta acción no se puede deshacer.');
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.fastWarrantiesService.deleteFastWarranty(warranty.id).subscribe(_ => {
                    this.utilsService.alert('Garantía rápida borrada correctamente', `Se ha eliminado la garantía rápida con id ${warranty.id} de la plataforma.`);
                    this.getWarranties();
                }, (error: ErrorResponse) => this.utilsService.alert('Error al borrar garantía', error.error?.descripcion));
            }
        });
    }

}
